import IconButton from "@mui/material/IconButton";
import { Link } from "react-router";
import ClearIcon from "@mui/icons-material/Clear";

export default function BackPageIconButton({ color }) {
	return (
		<Link to="..">
			<IconButton color={color ? color : "default"}>
				<ClearIcon />
			</IconButton>
		</Link>
	);
}
